import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle, longTextFormatter, booleanFormatter } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getNews, deleteNews } from '../../../../api/news'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(news) {
  let data = []
  for (let i = 0; i < news.length; ++i) {
      const elem = {}
      elem.title = news[i].title?.en
      elem.subtitle = news[i].subtitle?.en || '---'
      elem.content = news[i].content?.en || '---'
      elem.createdAt = news[i].createdAt
      elem.active = news[i].active
      elem.id = news[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function NewsPage() {
  const [data, setData] = useState([])
  const [newsId, setNewsId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-news/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setNewsId(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }

  const columns = [
    { dataField: 'title', text: 'Title', sort: true },
    { dataField: 'subtitle', text: 'Subtitle', sort: true },
    { dataField: 'content', text: 'Content', formatter: longTextFormatter, sort: true },
    { dataField: 'active', text: 'Active', formatter: booleanFormatter, sort: true },
    { dataField: 'createdAt', text: 'Created at', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getNews().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get news.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='News list'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/edit-news')}
              >
                Add new
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={'Are you sure you want to remove this news?'}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteNews(newsId).then(res => {
                if (res.status === 204 || res.status === 200 || res.status === 200) {
                  setRefresh(true)
                  alertSuccess({  title: 'Deleted!', customMessage: 'News removed successfully.' })
                }
              }).catch(error => {
                alertError({ error: error, customMessage: 'Could not remove news.' })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
